import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { IJwtTokenConstant } from '@core/constants/token/ijwt-token.constant';
import { IDecodedToken } from '@core/interfaces/authentication/idecoded-token';
import { IAuthenticatedResponse } from '@core/models/authentication/iauthenticated-response.model';

@Injectable({
  providedIn: 'root',
})
export class JwtBearerHelperService {
  private tokenInfo: IDecodedToken | null = null;
  private token: string | null = null;

  constructor(private _jwt: JwtHelperService) {
    const token = localStorage.getItem(IJwtTokenConstant.ACCESS_TOKEN_KEY);
    if (token) {
      this.token = token;
      this.tokenInfo = this._jwt.decodeToken(token) as IDecodedToken;
    }
  }

  get JWTToken(): string | null {
    return localStorage.getItem(IJwtTokenConstant.ACCESS_TOKEN_KEY) || null;
  }

  get hasToken(): boolean {
    return !!this.JWTToken;
  }

  get username(): string | null {
    return this.tokenInfo ? this.tokenInfo.username : null;
  }

  get isTokenExpired(): boolean {
    const token = this.JWTToken;
    return !token ? true : this._jwt.isTokenExpired(token);
  }

  get usuarioId(): number | null {
    return this.tokenInfo ? this.tokenInfo.usuarioId : null;
  }

  get ciudadanoId(): number | null {
    return this.tokenInfo ? this.tokenInfo.ciudadanoId : null;
  }

  get tokenInformation(): IDecodedToken | null {
    return this.tokenInfo;
  }

  saveToken(data: IAuthenticatedResponse | null, token?: string | null): void {
    debugger
    this.token = data == null ? token!: data.accessToken;

    localStorage.setItem(IJwtTokenConstant.ACCESS_TOKEN_KEY, this.token!);

    if (data){

      localStorage.setItem(IJwtTokenConstant.REFRESH_TOKEN_KEY, data.refreshToken);
      localStorage.setItem(IJwtTokenConstant.TOKEN_TYPE_KEY, data.tokenType);
      localStorage.setItem(IJwtTokenConstant.EXPIRES_IN_KEY, data.expiresIn.toString());

      this.tokenInfo = this._jwt.decodeToken(data.accessToken) as IDecodedToken;
    }
    
  }

  clearToken(): void {
    localStorage.clear();
    this.token = null;
    this.tokenInfo = null;
  }
}
